import axios from "axios";
import {closeModal, openModal, url} from "../../utilities";
import Spinner from "../../spinner";
import {toastAlert} from "../../toastAlert";
import {buildItemFromForm, itemFormCommon} from "./item-form-common";
import * as $ from "jquery";
import {emptyForm, enableFormBack, handleApiForm} from "../../forms";
import {confirmModal} from "../../confirmModal";


export const show = () => {

    const body = $('body');

    let currentId = null;

    itemFormCommon();

    body.on('click', '.btnEditItem', async function () {
        const spinner = new Spinner();

        currentId = $(this).data('id');

        try {
            const response = await axios.get(url(`api/inventories/${window._inventory_id}/items/${currentId}`));
            spinner.destroy();

            if (parseInt(response.data.code) !== 200) {
                toastAlert('Wystąpił błąd podczas próby załadowania danych.', {type: 'danger'})
                return;
            }

            openModal('#editItemModal');

            let typeInput = $('[name="type"]');
            let subtypeInput = $('[name="subtype"]');
            let quantityInput = $('[name="quantity"]');

            typeInput.val(response.data.item.inventory_animal_type_id).change();
            subtypeInput.val(response.data.item.inventory_animal_id).change();

            if (response.data.item.quantity && quantityInput.length > 0) {
                quantityInput.val(response.data.item.quantity);
            }

            for (let detail of response.data.item.details) {
                $(`[name="dictionary-${detail.id}"]`).val(detail.pivot.inventory_dictionary_entry_id);
            }
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby załadowania danych.', {type: 'danger'})
            spinner.destroy();
        }
    })



    $("#participantsTable").DataTable({
        "order": [[1, "asc"]],
        "stateSave": false,
    })

    $("#beatersTable").DataTable({
        "order": [[1, "asc"]],
        "stateSave": false,
    })

    $("#availableBeatersList").DataTable({
        "order": [[2, "asc"]],
        "stateSave": false,
    })

    $('#btnHideTable').click(async function () {

        if ($(this).text() === "Ukryj") {
            $(this).text("Pokaż");
        } else {
            $(this).text("Ukryj");
        }
        $(this).closest('.box-secondary').find(".table").toggle();
    })

    $('#btnHideList').click(async function () {

        if ($(this).text() === "Ukryj") {
            $(this).text("Pokaż");
        } else {
            $(this).text("Ukryj");
        }
        $(this).closest('.box-secondary').find(".table").toggle();
    })

    $('#btnHideComments').click(async function () {

        if ($(this).text() === "Ukryj") {
            $(this).text("Pokaż");
        } else {
            $(this).text("Ukryj");
        }
        $(this).closest('.box-info').find(".table").toggle();
    })

    $('#btnHideDogs').click(async function () {

        if ($(this).text() === "Ukryj") {
            $(this).text("Pokaż");
        } else {
            $(this).text("Ukryj");
        }
        $(this).closest('.box-info').find(".table").toggle();
    })

    $('#btnHideBeaters').click(async function () {

        if ($(this).text() === "Ukryj") {
            $(this).text("Pokaż");
        } else {
            $(this).text("Ukryj");
        }
        $(this).closest('.box-secondary').find(".table").toggle();
    })

    $('#btnEdit').click(async function () {
        let item = buildItemFromForm();

        const spinner = new Spinner();

        try {
            const response = await axios.post(
                url(`api/inventories/${window._inventory_id}/items/${currentId}`),
                {items: [item]}
            );
            spinner.destroy();

            if (parseInt(response.data.code) !== 200) {
                toastAlert(response.data.message, {type: 'danger'})
                return;
            }

            closeModal('#editItemModal');
            toastAlert(response.data.message)

            window.location.reload();
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby zapisu danych.', {type: 'danger'})
            spinner.destroy();
        }
    })

    // Add location comments form
    handleApiForm('#addGroupHuntingLocationComments', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#addLocationCommentsModal');

            let table = $('#locationCommentsTable').DataTable();

            let comment = response.data.comment;
            let row = $(`
                <tr data-id="${comment.id}">
                    <td>${comment.location.name}</td>
                    <td class="comment__comments">${comment.comments}</td>
                    <td>${comment.date}</td>
                    <td>${comment.author}</td>
                    <td>
                        <button data-id="${comment.id}" data-location_id="${comment.location.id}" type="button" class="btn btn-sm btn-primary btnEditLocationComment">
                            Edytuj
                        </button>
                        <button data-id="${comment.id}" type="button" class="btn btn-sm btn-danger btnDeleteLocationComment">
                            Usuń
                        </button>
                    </td>
                </tr>
            `)

            table.api().rows.add(row).draw(false);

            emptyForm(form);
            toastAlert('Pomyślnie dodano uwagi do polowania');
        }
    })

    // Edit location comments
    body.on('click', '.btnEditLocationComment', async function () {

        let id = $(this).data('id');
        let form = $("#editGroupHuntingLocationComments");

        let table = $('#locationCommentsTable').DataTable();
        let comments = table.api().$(`tr[data-id="${id}"]`).find('.comment__comments').text();

        form.attr('action', window._EDIT_LOCATION_COMMENTS_URL.replace('REPLACE_ID', id));
        form.find('[name="group_hunting_location_id"]').val($(this).data('location_id'));
        form.find('[name="comments"]').val(comments);

        openModal('#editLocationCommentsModal')
    })

    // Edit location comments form
    handleApiForm('#editGroupHuntingLocationComments', ({response, form}) => {

        if (response.data.code === 200) {
            closeModal('#editLocationCommentsModal');

            let table = $('#locationCommentsTable').DataTable();
            let comment = response.data.comment;

            let row = table.$(`tr[data-id="${comment.id}"]`);
            let rowIndex = table.api().row(row).index();

            table.api().cell(rowIndex, 1).data(comment.comments);

            emptyForm(form);
            toastAlert('Pomyślnie edytowano uwagi do polowania');
        }
    })

    // Delete location
    body.on('click', '.btnDeleteLocationComment', async function() {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć wybrane uwagi do miotu?', {color: 'danger'});
        if (!confirm) return;

        let id = $(this).data('id');

        try {
            const response = await axios.post(window._DELETE_LOCATION_COMMENTS_URL.replace('REPLACE_ID', id));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let table = $('#locationCommentsTable').DataTable();
            let row = table.$(`tr[data-id=${$(this).data('id')}]`)
            table.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto uwagi');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia uwag', {type: 'danger'})
        }
    })


    if($("#availableMembersList").length > 0) {

        $("#groupHuntingAddParticipantFromList").submit(function (e) {
            e.preventDefault();

            let inputs = $("#availableMembersList").DataTable().$('input');

            for(let input of inputs) {

                if($(input).prop('checked') === true && $(input).val() !== "") {
                    $(this).append(`<input type="hidden" name="users_id[${$(input).val()}]" value="${$(input).val()}" />`);
                }
            }
            this.submit();
        });
    }

    if($("#availableBeatersList").length > 0) {
        $("#groupHuntingAddBeaterFromList").submit(function (e) {
            e.preventDefault();

            let inputs = $("#availableBeatersList").DataTable().$('input');

            for(let input of inputs) {

                if($(input).prop('checked') === true && $(input).val() !== "") {
                    $(this).append(`<input type="hidden" name="users_id[${$(input).val()}]" value="${$(input).val()}" />`);
                }
            }
            this.submit();
        })
    }

    handleApiForm('#addGroupHuntingDogs', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#addDogsModal');

            let table = $('#dogsTable').DataTable();

            let comment = response.data.dog;
            let row = $(`
                <tr data-id="${comment.id}">
                    <td>${comment.name}</td>
                    <td class="dog__comments">${comment.comments}</td>
                    <td>
                        <button data-id="${comment.id}" type="button" class="btn btn-sm btn-danger btnDeleteDog">
                            Usuń
                        </button>
                    </td>
                </tr>
            `)

            table.api().rows.add(row).draw(false);

            emptyForm(form);
            toastAlert('Pomyślnie dodano psa');
        }
    })


    body.on('click', '.btnDeleteDog', async function() {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć tego psa?', {color: 'danger'});
        if (!confirm) return;

        let id = $(this).data('id');

        try {
            const response = await axios.post(window._DELETE_DOG_URL.replace('REPLACE_ID', id));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let table = $('#dogsTable').DataTable();
            let row = table.$(`tr[data-id=${$(this).data('id')}]`)
            table.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto psa');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia psa', {type: 'danger'})
        }
    })


    body.on('click', '.btnDeleteShooting', async function() {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć wpis?', {color: 'danger'});
        if (!confirm) return;

        let id = $(this).data('id');


        try {
            const response = await axios.post(window._DELETE_SHOOTING_URL.replace('REPLACE_ID', id));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let table = $('#animalsTable').DataTable();
            let row = table.$(`tr[data-id=${$(this).data('id')}]`)

            table.api().row(row).remove().draw();

            toastAlert('Pomyślnie usunięto wpis');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia wpisu', {type: 'danger'})
        }
    })


    body.on('click', '.btnDeleteShootingAll', async function() {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć wpis?', {color: 'danger'});
        if (!confirm) return;

        let id = $(this).data('id');

        try {
            const response = await axios.post(window._DELETE_SHOOTING_URL.replace('REPLACE_ID', id));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let table = $('#animalsTableAll').DataTable();
            let row = table.$(`tr[data-id=${$(this).data('id')}]`)
            table.api().row(row).remove().draw();


            toastAlert('Pomyślnie usunięto wpis');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia wpisu', {type: 'danger'})
        }
    })


    body.on('click', '.btnChangeAttendance', async function () {

        try {
            let button = $(this);
            let url = window.ATTENDANCE_STATUS_URL.replace('REPLACE_ID', $(this).data('app-id'));
            const response = await axios.post(url);

            if (response.data.code !== 200) {
                let err = new Error(response.data.errors);
                err.code = response.data.code;

                throw err;
            }

            const participant = response.data.participant;

            let row = button.closest('tr');

            let attendanceCell = row.find('td:nth-child(3)');
            attendanceCell.text(participant.is_present ? "Tak" : "Nie");


            toastAlert('Pomyślnie zmienono status obecności');
        } catch (err) {
            if (err.code === 400) {
                toastAlert(err.message, {type: 'danger'})
                return;
            }

            toastAlert('Wystąpił błąd podczas próby zmiany statusu obecności', {type: 'danger'})
        }
    })


}